<template>
  <Card
    class="relative w-full mb-30 flex-1"
    centerContent
    :title="cardTitle"
    icon="CalendarStar"
    accentColor="sky"
  >
    <div v-if="isActiveScheduledAppointment()" class="flex flex-col w-full">
      <ScheduledAppointment v-if="appointmentIsSuccess" />
      <PendingAppointment v-else-if="appointmentIsPending" />
    </div>
    <div
      v-else-if="isFetchingScheduledAppointment"
      class="flex flex-col h-150 justify-center items-center self-center"
    >
      <Icon iconClass="fas fa-spinner fa-pulse fa-6x" />
    </div>
    <div v-else class="w-full flex flex-col items-center">
      <div
        v-if="showDemoPhoneOverride"
        class="flex self-start flex-col p-16 bg-yellow-100 w-full"
      >
        <div class="flex items-center justify-between w-full">
          <Icon
            iconClass="fas fa-times"
            class="cursor-pointer p-16 absolute right-0"
            @click="didCloseOverrideSection = true"
          />
          <TypographyH3 class="font-semibold">
            {{ 'DEMO-ONLY' }}
          </TypographyH3>
        </div>
        <p class="text-sm text-grey-500 mb-8">
          {{ 'Provide a phone number to receive calls made by the agent' }}
        </p>
        <input
          :value="demoPhoneOverride"
          placeholder="Enter phone number"
          class="w-1/2 border border-grey-200 rounded-md p-8 px-16"
          @input="(e) => setDemoPhoneOverride(e.target.value)"
        />
      </div>
      <div
        class="w-3/4 sm:w-1/2 py-20 flex flex-col items-center self-center justify-evenly gap-12"
      >
        <div class="justify-center flex">
          <div
            class="w-60 h-60 rounded-full bg-sky-100 self-center flex items-center justify-center"
          >
            <Icon
              iconClass="far fa-calendar text-4xl text-sky-500 self-center"
            />
          </div>
        </div>
        <TypographyBody class="text-center">
          <span class="block font-bold">{{
            $t('health_actions.scheduling.ready_to_schedule_title')
          }}</span>
        </TypographyBody>
        <TypographyBody class="text-center">
          <span class="block text-sm">{{
            $t('health_actions.scheduling.ready_to_schedule_description')
          }}</span>
        </TypographyBody>
        <HMButton
          class="w-full sm:w-3/4"
          rounded="full"
          :to="{
            name: 'scheduling',
          }"
        >
          {{ $t('health_actions.scheduling.schedule_visit') }}
        </HMButton>
      </div>
    </div>
  </Card>
</template>

<script>
import { Card } from '@components/common/card/index'
import healthActionMixin from '@platform-shared/mixins/health-actions/healthActionMixin.js'
import { mapActions, mapGetters } from 'vuex'
import ScheduledAppointment from './ScheduledAppointment.vue'
import Icon from '~/components/common/Icon.vue'
import TypographyBody from '~/components/common/Typography/Body.vue'
import PendingAppointment from './PendingAppointment.vue'
import TypographyH3 from '~/components/common/Typography/H3.vue'

export default {
  name: 'OnlineSchedulingCard',
  components: {
    Card,
    TypographyBody,
    Icon,
    ScheduledAppointment,
    PendingAppointment,
    TypographyH3,
  },
  mixins: [healthActionMixin],
  data() {
    return {
      didCloseOverrideSection: false,
    }
  },
  computed: {
    ...mapGetters('scheduling', [
      'scheduledAppointment',
      'appointmentIsPending',
      'appointmentIsSuccess',
      'isFetchingScheduledAppointment',
      'demoPhoneOverride',
    ]),
    ...mapGetters('client', ['hasFeature']),
    cardTitle() {
      return this.scheduledAppointment
        ? this.$t('health_actions.scheduling.scheduled')
        : this.$t('health_actions.scheduling.scheduling')
    },
    showDemoPhoneOverride() {
      return (
        this.hasFeature('ONLINE_SCHEDULING_DEMO_PHONE_OVERRIDE') &&
        !this.didCloseOverrideSection
      )
    },
  },
  mounted() {
    this.fetchPcpsOnFile()
  },
  methods: {
    ...mapActions('scheduling', ['fetchPcpsOnFile', 'setDemoPhoneOverride']),
  },
}
</script>
